// ============================================
// CASE STATUS BADGE — Quiet dot + label
// ============================================
// Replaces loud uppercase pill badges with a subtle
// colored dot and sentence-case text. Status is glanceable
// without competing with the case title.

interface CaseStatusBadgeProps {
  status: string; // display status from getCaseStatus()
  caseStatus?: string; // raw case_status field
}

const BADGE_CONFIG: Record<
  string,
  { dot: string; text: string; label: string }
> = {
  new: { dot: "bg-slate-300", text: "text-slate-400", label: "Draft" },
  draft: { dot: "bg-slate-300", text: "text-slate-400", label: "Draft" },
  letter_ready: {
    dot: "bg-teal-400",
    text: "text-slate-400",
    label: "Letter ready",
  },
  denied: { dot: "bg-red-400", text: "text-slate-400", label: "Denied" },
  appealed: { dot: "bg-amber-400", text: "text-slate-400", label: "Appealed" },
  submitted: { dot: "bg-blue-400", text: "text-slate-400", label: "Submitted" },
  pending: { dot: "bg-blue-400", text: "text-slate-400", label: "Pending" },
  approved: {
    dot: "bg-emerald-400",
    text: "text-slate-400",
    label: "Approved",
  },
};

export function CaseStatusBadge({ status, caseStatus }: CaseStatusBadgeProps) {
  // Prefer caseStatus (raw DB field) when available, fall back to derived status
  const key = caseStatus || status || "draft";
  const config = BADGE_CONFIG[key] || BADGE_CONFIG.draft;

  return (
    <span
      className={`inline-flex items-center gap-1.5 text-[10px] font-medium whitespace-nowrap ${config.text}`}
    >
      <span
        className={`w-[5px] h-[5px] rounded-full flex-shrink-0 ${config.dot}`}
      />
      {config.label}
    </span>
  );
}
